import * as React from 'react';
import { cs } from '@shared/utils/utils-classname';
import { observer } from 'mobx-react';

type SelectMode = 'click' | 'area';

@observer
export class SelectionModePicker extends React.Component<{
    value: SelectMode;
    onChange: (mode: SelectMode) => void;
    onClose: () => void;
}> {
    render() {
        return (
            <div id='logpoints-bulk-empty'>
                <div id='logpoints-bulk-selection-mode'>
                    <button onClick={() => this.props.onChange('click')} className={cs({ 'ik-button-secondary--subtle': this.props.value == 'area' })}>
                        <input type='radio' readOnly={true} checked={this.props.value == 'click'} />
                        <div>
                            <h4>{__('js_map.click_to_select')}</h4>
                            {__('js_map.click_to_select_desc')}
                        </div>
                    </button>

                    <button onClick={() => this.props.onChange('area')} className={cs({ 'ik-button-secondary--subtle': this.props.value == 'click' })}>
                        <input type='radio' readOnly={true} checked={this.props.value == 'area'} />
                        <div>
                            <h4>{__('js_map.area_selection')}</h4>
                            <div>
                                {__('js_map.draw_polygon_to_select_items')}. {__('js_map.hold_shift_for_freehand_drawing')}
                            </div>
                        </div>
                    </button>
                </div>

                <button onClick={this.props.onClose} className='ik-button-secondary--subtle'>
                    <i className='iki iki-chevron-left' /> <span>{__('general.close')}</span>
                </button>
            </div>
        );
    }
}
